import React from "react";
import classes from "./Chart.module.css";
import { Radar } from "react-chartjs-2";

import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const Chart = (props) => {
  const chartData = props.data || [];

  // Labels = stages
  const labels = chartData.map((item) => item.stage);

  // Values = engagement score per stage
  const values = chartData.map((item) => item.total);

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Engagement Score by Stage",
        data: values,
        backgroundColor: "rgba(53, 162, 235, 0.3)",
        borderColor: "rgb(53, 162, 235)",
        borderWidth: 2,
        pointBackgroundColor: "rgb(53, 162, 235)",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: "Engagement by Stage",
      },
      legend: {
        display: true,
      },
    },
    scales: {
      r: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div className={classes.chart} style={{ height: "600px" }}>
      <Radar data={data} options={options} />
    </div>
  );
};

export default Chart;